var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuadrat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      WebkitTransform: "translateY(-3px)",
      msTransform: "translateY(-3px)",
      transform: "translateY(-3px)"
    },
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_111",
    x: 11.9,
    y: 0,
    width: 30.1,
    height: 30.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_112",
    x: 0,
    y: 2.5,
    width: 39.5,
    height: 39.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QUADRAT",
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_111)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_111-2",
    "data-name": "Pfad 111",
    className: "cls-1",
    d: "M17,22.1H30.9v2H36V19H33.9V5.1H36V0H30.9V2.1H17V0H11.9V5.1h2V19h-2v5.1H17ZM35,20v3.1H31.9V20H35ZM31.9,3.1V1H35V4.1H31.9v-1ZM17,3.1H30.9v2h2V19h-2v2.1H17V19H14.9V5.1H17Zm-4.1,1V1H16V4.1H12.9Zm3.1,17v2H12.9V20H16Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_112)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_112-2",
    "data-name": "Pfad 112",
    fill: "#f5f5f5",
    d: "M31.1,27.2A16.006,16.006,0,0,1,2,18,15.749,15.749,0,0,1,8.9,4.9V2.5A17.995,17.995,0,1,0,33.5,27.2Z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadrat);
export default __webpack_public_path__ + "static/media/quadrat.0c62dade87e5efb6fa4826e760869ea5.svg";
export { ForwardRef as ReactComponent };